(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("projectMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 905,
                    parameters: parms || {}
                });
            },
            createDocumentPack: function (menu) {
                return $ihttp.post({
                    method: 3288,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
